import { Component, AfterViewInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements AfterViewInit, OnDestroy {
  public heroImages: { maxWidth: number; image: string }[] = [
    { maxWidth: 767, image: 'hero_image_S.png' },
    { maxWidth: 1023, image: 'hero_image_M.png' },
    { maxWidth: 1439, image: 'hero_image_L.png' },
    { maxWidth: 1800, image: 'hero_image_XL.png' }
  ];
  public overlayImages: { maxWidth: number; image: string }[] = [
    { maxWidth: 767, image: 'Ascendiun_White-S.png' },
    { maxWidth: 1023, image: 'Ascendiun_White-M.png' },
    { maxWidth: 1439, image: 'Ascendiun_White-L.png' },
    { maxWidth: 1800, image: 'Ascendiun_White-XL.png' }
  ];
  public overlayText: string = 'Health care that moves faster and aims higher';
  public ourstory: string = 'At Ascendiun, we believe in a brighter future for health care. As the parent to a family of innovative health care companies, we’re reimagining what’s possible — creating a future where care is simpler, smarter, and more affordable for everyone.';
  public peopleImages: { maxWidth: number; image: string }[] = [
    { maxWidth: 767, image: 'plans_S.png' },
    { maxWidth: 1023, image: 'plans_M.png' },
    { maxWidth: 1439, image: 'plans_L.png' },
    { maxWidth: 1800, image: 'plans_XL.png' }
  ];
  public peopleTitle: string = 'Turningthe industry’s largest challenges into opportunities';
  public peopleContent: { title: string; description: string; linkText: string; linkPath: string }[] = [
    {
      title: 'Blue Shield of California',
      description: 'Non-profit, mission driven health plan.',
      linkText: 'Explore Blue Shield',
      linkPath: 'https://www.blueshieldca.com'
    },
    {
      title: 'Blue Shield of California Promise Health Plan',
      description: 'A managed care organization, wholly owned by Blue Shield of California, offering Medi-Cal plans.',
      linkText: 'Explore Blue Shield Promise Health Plan',
      linkPath: 'https://www.blueshieldca.com/en/bsp'
    },
    {
      title: 'Stellarus',
      description: 'Offers health plans the capabilities to be able to transform health care at scale.',
      linkText: 'Explore Stellarus',
      linkPath: 'https://www.stellarus.com'
    },
    {
      title: 'Altais',
      description: 'Empowers physicians and the organizations that work with them to practice medicine worthy of our family and friends in a fulfilling work environment.',
      linkText: 'Explore Altais',
      linkPath: 'https://altais.com'
    },
  ];
  public teaserImages: { image: string; name: string; title: string }[] = [
    { image: 'image_1.png', name: 'First last name', title: 'Job title' },
    { image: 'image_2.png', name: 'First last name', title: 'Job title' },
    { image: 'image_1.png', name: 'First last name', title: 'Job title' },
    { image: 'image_2.png', name: 'First last name', title: 'Job title' }
  ];

  hideStickyNav: boolean = false;
  private footerObserver?: IntersectionObserver;

  constructor(readonly router: Router) { }

  openLink(url: string) {
    if (url.startsWith('http') || url.startsWith('www') || url.startsWith('https')) {
      window.open(url, '_blank');
    } else {
      this.router.navigate([url]);
    }
  }

  readonly mail_text: string = "mailto:contactus@ascendiun.com?subject=Ascendiun Inquiry";

  ngAfterViewInit(): void {
    const footerEl = document.querySelector('app-footer');
    if (footerEl) {
      this.footerObserver = new IntersectionObserver((entries) => {
        // Hide sticky nav when footer is visible in the viewport
        this.hideStickyNav = entries.some(e => e.isIntersecting);
      }, { root: null, threshold: 0 });
      this.footerObserver.observe(footerEl);
    }
  }

  ngOnDestroy(): void {
    this.footerObserver?.disconnect();
  }
}
